import { booleanAttribute, Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "li[listbox-element], listbox-element",
  templateUrl: "./listbox-element.component.html",
  styleUrls: ["./listbox-element.component.scss"],
})
export class ListboxElementComponent {
  @Input({ transform: booleanAttribute }) disableHoverBorder = false;

  @HostBinding("attr.tabindex") readonly tabIndex = 0;

  @HostBinding("class.disable-hover-border")
  get disableHoverBorderClass(): boolean {
    return this.disableHoverBorder;
  }
}
